<template>
  <div>
    <!-- form start -->
    <form class="register-form">
      <!-- row start -->
      <div class="row">
        <div class="col-md-12 text-center">
          <h3 class="register-title">Register {{ event.name }}</h3>
        </div>
      </div>

      <div class="row mt-60">
        <!--  -->
        <div class="col-sm-12">
          <div class="form-group mb-30">
            <label>Nama Peserta 1<sup>*</sup></label>
            <input
              type="text"
              name="name"
              class="form-control"
              placeholder="Nama Peserta 2"
              v-model="data.name"
              v-validate="'required'"
              :disabled="!isEdit"
              data-vv-as="Nama Peserta 1"
            />
            <div class="text-danger">{{ veeErrors.first("name") }}</div>
          </div>
        </div>
        <!--  -->
        <div class="col-sm-12">
          <div class="form-group mb-30">
            <label>Nama Peserta 2<sup>*</sup></label>
            <input
              type="text"
              name="companion"
              class="form-control"
              placeholder="Nama Peserta 2"
              v-model="data.companion"
              v-validate="'required'"
              :disabled="!isEdit"
              data-vv-as="Nama Peserta 2"
            />
            <div class="text-danger">{{ veeErrors.first("companion") }}</div>
          </div>
        </div>
        <!--  -->
        <div class="col-sm-12">
          <div class="form-group mb-30">
            <label>Toko<sup>*</sup></label>
            <input
              type="text"
              name="toko"
              class="form-control"
              placeholder="Nama Toko"
              v-model="data.toko"
              v-validate="'required'"
              :disabled="!isEdit"
              data-vv-as="Nama Toko"
            />
            <div class="text-danger">{{ veeErrors.first("toko") }}</div>
          </div>
        </div>
        <!--  -->
        <div class="col-sm-12 mt-5">
          <div class="form-group mb-30">
            <button
              class="btn btn-success"
              data-loading-text="Please wait..."
              @click.prevent="submit"
            >
              Submit
            </button>
          </div>
        </div>
        <!--  -->
      </div>
      <!-- row end -->

      <!-- row end -->
    </form>
    <!-- form end -->
  </div>
</template>

<script>
export default {
  props: ["event"],
  filters: {
    formatSize: function (value) {
      if (!value) return "";
      let valKB = 0.000001 * value;
      return `${valKB.toFixed(2)} MB`;
    },
  },
  data() {
    return {
      url: "",
      token: document.head.querySelector('meta[name="csrf-token"]').content,
      type: "",
      main_folder: "file_upload/bukti_bayar",
      data: {
        name: null,
        companion: null,
        toko: null,
      },
      files: [],
      isEdit: true,
    };
  },
  created() {
    this.initial();
  },
  methods: {
    initial() {
      this.data.event_id = this.event.id;
      //   this.checkEmail();
    },
    checkEmail() {
      this.$validator.extend("email_exists", {
        getMessage: (field) => `This email has been registered`,
        validate: (value) => {
          return axios
            .get("/register/checkemail/" + value)
            .then((response) => {
              return {
                valid: response.data.valid,
              };
            })
            .catch((error) => {
              return { error: response.error.val };
            });
        },
      });
    },
    submit() {
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.confirmAlert("Confirm", "Submit now?", "axiosForm");
        } else {
          this.$swal("Warning!", "Lengkapi semua isian!", "warning");
        }
      });
    },
    confirmAlert(msg, txt, action) {
      this.$swal({
        title: msg,
        text: txt,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.isConfirmed) {
          switch (action) {
            case "axiosForm":
              this.axiosForm(this.data);
              break;
          }
        }
      });
    },
    axiosForm(data) {
      let url = `/register/${this.event.slug}/create`;
      axios
        .post(url, data)
        .then((response) => {
          let msg = response.data.message;

          switch (msg) {
            case "exists":
              this.$swal("Error!", "Email telah terdaftar!", "error");
              break;
            case "success":
              let dataEmit = {
                action: "notif",
                data: response.data.data,
              };
              this.$emit("data-prop", dataEmit);
              break;
            default:
              this.$swal("Error!", "Maaf, terjadi kesalahan!", "error");
              break;
          }
        })
        .catch((err) => {
          this.$swal("Error!", "Maaf, terjadi kesalahan!", "error");
        });
    },
    formatRupiah(money) {
      return new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
      }).format(money);
    },
    customLabel({ name, price }) {
      price = this.formatRupiah(price);
      return `${name} (${price})`;
    },
    getImage(link) {
      return `${this.main_folder}/${link}`;
    },
    validateFileSize(size) {
      //   if (0.000001 * size > 2.048) {
      //     return false;
      //   }
      return true;
    },
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Before adding a file
        // 添加文件前
        // Filter system files or hide files
        // 过滤系统文件 和隐藏文件
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent();
        }
        // Filter php html js file
        // 过滤 php html js 文件
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent();
        }
      }
    },
    inputFile(newFile, oldFile) {
      if (newFile) {
        let check = this.validateFileSize(newFile.size);
        if (!check) {
          this.$refs.upload.remove(newFile);
          this.$swal("Error!", "Max file upload 2 MB.", "error");
        } else {
          this.$refs.upload.active = true;
        }
      }
    },
    async uploadFile(file, component) {
      let result = await component.uploadHtml5(file),
        filename = result.response.filename;
      this.files[0].name = filename;
      this.data.bukti_bayar = filename;
      return result;
    },
    formData(obj) {
      var formData = new FormData();
      for (var key in obj) {
        formData.append(key, obj[key]);
      }
      return formData;
    },
    alertError(msg) {
      this.$swal({
        icon: "error",
        title: "Maaf terdapat gangguan, silahkan coba kembali",
        text: msg,
        type: "warning",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Mengerti",
      }).then((result) => {
        if (result.value) {
        }
      });
    },
  },
};
</script>
<style>
h1,
h2,
h3,
h4,
h5,
h6 {
  letter-spacing: normal;
}
.register-form {
  color: #444;
  background-color: #fff;
  border: 2px solid #ddd;
  border-radius: 10px;
  padding: 30px 30px;
  box-shadow: 0 4px 21px -12px rgb(0 0 0 / 66%);
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}
.register-form label,
.register-form input {
  font-size: 1.2em;
}
.register-form sup{
    color: #dc3545;
}
.register-title {
  font-weight: bold;
}
.box-info {
  background: #eee;
  padding: 10px 20px;
}
option:disabled {
  background: rgb(170, 170, 170);
}
@media screen and (max-width: 768px) {
  .datepicker.flex.flex-direction-column {
    max-width: unset !important;
    min-width: unset !important;
    width: 100% !important;
  }
}
</style>
